import styled from 'styled-components/macro'

export const StyledDateTimeInput = styled.div`
  max-width: 20rem;
`

export const Line = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`
